import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import { profileStore } from './modules/profile'
import { modalStateStore } from './modules/state.modal'
import { rootState } from './state';
import { basketStore } from './modules/basket';
import { networkStateStore } from './modules/state.network';
import { regionStore } from './modules/region';
import { SiteConfStore } from './modules/site'


Vue.use(Vuex)
interface RootState {

}

let store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state: rootState,
    mutations,
    actions,
    modules: {
        profile: profileStore,
        modal: modalStateStore,
        basket: basketStore,
        network: networkStateStore,
        region: regionStore,
        siteConf: SiteConfStore
    }
})
store.state
export default store